<template>
  <div>
    <Head :title="`${form.name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/skus">SKUs</Link>
        <span class="text-orange-400 font-medium">/</span>
        {{ form.name }}
      </h1>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Description" />
          <select-input v-model="form.unit_id" :error="form.errors.unit_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Unit of Measure">
            <option
              v-for="unit in units"
              :key="unit.id"
              :value="unit.id"
            >{{ unit.name }}</option>
          </select-input>
          <select-input v-model="form.category_id" :error="form.errors.category_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Category">
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >{{ category.name }}</option>
          </select-input>
          <text-input v-model="form.standard_quantity" :error="form.errors.standard_quantity" class="pb-8 pr-6 w-full lg:w-1/2" label="Standard Quantity" />
          <text-input v-model="form.cbm" :error="form.errors.cbm" class="pb-8 pr-6 w-full lg:w-1/2" label="CBM" />
          <text-input v-model="form.minimum_qty" :error="form.errors.minimum_qty" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Minimum Qantity" />
          <select-input v-model="form.status" :error="form.errors.status" class="pb-8 pr-6 w-full lg:w-1/2" label="Status">
            <option
              v-for="(status, indexx) in statuses"
              :key="indexx"
              :value="indexx"
            >{{ status }}</option>
          </select-input>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Update SKU</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    categories: Object,
    sku: Object,
    units: Object,
    statuses: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.sku.name,
        description: this.sku.description,
        unit_id: this.sku.unit_id,
        category_id: this.sku.category_id,
        standard_quantity: this.sku.standard_quantity,
        cbm: this.sku.cbm,
        minimum_qty: this.sku.minimum_qty,
        status: this.sku.status,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/skus/${this.sku.id}`)
    },
  },
}
</script>
